import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import posthog from "@/lib/posthog";

const STORAGE_KEY = "cookie-consent";

export type CookieConsentStatus = "accepted" | "declined" | null;

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setVisible(true);
    }
  }, []);

  function handleAccept() {
    localStorage.setItem(STORAGE_KEY, "accepted");
    posthog.opt_in_capturing();
    setVisible(false);
  }

  function handleDecline() {
    localStorage.setItem(STORAGE_KEY, "declined");
    posthog.opt_out_capturing();
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6">
      <div className="mx-auto max-w-3xl rounded-xl border border-border bg-background shadow-lg p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="shrink-0 text-muted-foreground mt-0.5" size={20} />
        <p className="text-sm text-muted-foreground flex-1">
          We use cookies to improve your experience and analyze site usage. By continuing, you agree to our{" "}
          <a href="/privacy-policy" className="underline underline-offset-2 hover:text-foreground transition-colors">
            Privacy Policy
          </a>
          .
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={handleDecline}>
            Decline
          </Button>
          <Button size="sm" onClick={handleAccept}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}

export function getCookieConsent(): CookieConsentStatus {
  return (localStorage.getItem(STORAGE_KEY) as CookieConsentStatus) ?? null;
}
